/* ===========================================================
   AREON — Mallikivi-logiikka (Dawn)
   =========================================================== */
(function () {
  'use strict';

  const SAMPLE_PROP = '_sample';

  /* Käännökset Liquid-puolelta; fallback suomeksi jos puuttuu */
  const S = window.areonSampleStrings || {};
  function t(key, vars) {
    const fallbacks = {
      remainingOne: 'Voit valita vielä 1 mallikiven',
      remainingMany: 'Voit valita vielä %COUNT% mallikiveä',
      full: 'Valinta täynnä — valmiina kassalle',
      limitToast: 'Voit tilata enintään %MAX% mallikiveä. Poista ensin yksi valinta.',
      checkoutBlocked: 'Voit tilata enintään %MAX% mallikiveä veloituksetta. Poista yksi mallikivi jatkaaksesi.',
      errorGeneric: 'Jotain meni pieleen. Yritä uudelleen.',
    };
    let str = S[key] || fallbacks[key] || '';
    if (vars) Object.keys(vars).forEach((k) => { str = str.replace(k, vars[k]); });
    return str;
  }

  /* ---------- Apufunktiot ---------- */
  async function getCart() {
    const res = await fetch(`${window.Shopify.routes.root}cart.js`, {
      headers: { Accept: 'application/json' },
    });
    return res.json();
  }

  /* Mallikivi tunnistetaan _sample-propertysta TAI variantin nimestä,
     jotta myös tuotesivun varianttivalitsimen kautta lisätyt näkyvät. */
  const VARIANT_NAME = ((window.areonSampleCartConfig || {}).variantName || 'mallikivi').toLowerCase();
  function isSample(item) {
    const p = item.properties || {};
    if (p[SAMPLE_PROP] === 'true') return true;
    const vt = (item.variant_title || '').toLowerCase();
    return vt.indexOf(VARIANT_NAME) !== -1;
  }

  function countSamples(cart) {
    return cart.items.reduce((n, item) => (isSample(item) ? n + item.quantity : n), 0);
  }

  function sampleVariantIds(cart) {
    return cart.items.filter(isSample).map((i) => i.variant_id);
  }

  async function addSample(variantId) {
    const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1, properties: { [SAMPLE_PROP]: 'true' } }],
        sections: cartBubbleSections(),
        sections_url: window.location.pathname,
      }),
    });
    const data = await res.json();
    updateCartBubble(data.sections);
    return data;
  }

  /* ---------- Korinumeron (cart bubble) päivitys ---------- */
  function cartBubbleSections() {
    // Pyydetään ne sectionit jotka sisältävät korinumeron. Dawnissa nämä ovat
    // tyypillisesti 'cart-icon-bubble' ja 'cart-live-region-text'.
    const ids = [];
    if (document.getElementById('cart-icon-bubble')) ids.push('cart-icon-bubble');
    if (document.getElementById('cart-live-region-text')) ids.push('cart-live-region-text');
    return ids.length ? ids : ['cart-icon-bubble'];
  }

  function updateCartBubble(sections) {
    if (!sections) return;
    // Vaihda jokaisen pyydetyn sectionin sisältö DOM:iin
    Object.keys(sections).forEach((id) => {
      const html = sections[id];
      if (!html) return;
      const target = document.getElementById(id);
      if (!target) return;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      // Dawnin cart-icon-bubble: sisältö on #shopify-section-... sisällä
      const fresh =
        parsed.getElementById(id) ||
        parsed.querySelector(`#shopify-section-${id}`) ||
        parsed.body;
      if (fresh) target.innerHTML = fresh.innerHTML;
    });
  }

  async function removeLine(variantId) {
    // Etsi line item -avain (key) variant_id:n perusteella
    const cart = await getCart();
    const line = cart.items.find(
      (i) => i.variant_id === variantId && isSample(i)
    );
    if (!line) return cart;
    const res = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: line.key,
        quantity: 0,
        sections: cartBubbleSections(),
        sections_url: window.location.pathname,
      }),
    });
    const data = await res.json();
    updateCartBubble(data.sections);
    return data;
  }

  /* ---------- Section-init ---------- */
  document.querySelectorAll('[id^="areon-sample-grid-"]').forEach(initSection);

  function initSection(grid) {
    const sectionId = grid.id.replace('areon-sample-grid-', '');
    const MAX = parseInt(grid.dataset.maxSamples, 10) || 2;
    const tray = document.getElementById(`areon-sample-tray-${sectionId}`);
    if (!tray) return;

    const countEl = tray.querySelector('[data-sample-count]');
    const chipsEl = tray.querySelector('[data-sample-chips]');
    const noteEl = tray.querySelector('[data-sample-note]');
    const checkoutBtn = tray.querySelector('[data-sample-checkout]');
    let busy = false;

    const toast = (() => {
      let el;
      return (msg) => {
        if (!el) {
          el = document.createElement('div');
          el.className = 'areon-sample__toast';
          document.body.appendChild(el);
        }
        el.textContent = msg;
        el.classList.add('is-visible');
        clearTimeout(el._t);
        el._t = setTimeout(() => el.classList.remove('is-visible'), 2800);
      };
    })();

    async function refresh() {
      const cart = await getCart();
      const ids = sampleVariantIds(cart);
      const count = ids.length;

      // Kortit
      grid.querySelectorAll('.areon-sample__card').forEach((card) => {
        const vid = parseInt(card.dataset.variantId, 10);
        const selected = ids.includes(vid);
        card.classList.toggle('is-selected', selected);
        const btn = card.querySelector('.areon-sample__add');
        const label = btn.querySelector('.areon-sample__add-label');
        btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
        label.textContent = selected
          ? label.dataset.labelSelected
          : label.dataset.labelAdd;
        // disabloi lisäys jos täynnä eikä tämä ole valittu
        btn.disabled = !selected && count >= MAX;
      });

      // Tray
      countEl.textContent = count;
      tray.hidden = count === 0;
      tray.classList.toggle('is-visible', count > 0);
      checkoutBtn.disabled = count === 0;

      const left = MAX - count;
      noteEl.textContent =
        count === 0
          ? ''
          : left > 0
          ? (left === 1 ? t('remainingOne') : t('remainingMany', { '%COUNT%': left }))
          : t('full');

      // Chips
      chipsEl.innerHTML = '';
      ids.forEach((vid) => {
        const card = grid.querySelector(`.areon-sample__card[data-variant-id="${vid}"]`);
        const name = card ? card.querySelector('.areon-sample__add').dataset.name : 'Näyte';
        const chip = document.createElement('span');
        chip.className = 'areon-sample__chip';
        chip.innerHTML = `<span>${name}</span><button type="button" aria-label="Poista">&times;</button>`;
        chip.querySelector('button').addEventListener('click', () => toggle(vid));
        chipsEl.appendChild(chip);
      });

      // Synkkaa checkout-napit muualla sivulla (cart notification ym.)
      enforceCheckoutGuards(count, MAX);
    }

    async function toggle(variantId) {
      if (busy) return;
      busy = true;
      try {
        const cart = await getCart();
        const ids = sampleVariantIds(cart);
        if (ids.includes(variantId)) {
          await removeLine(variantId);
        } else {
          if (ids.length >= MAX) {
            toast(t('limitToast', { '%MAX%': MAX }));
            busy = false;
            return;
          }
          await addSample(variantId);
        }
        await refresh();
        document.dispatchEvent(new CustomEvent('areon:sample-updated'));
      } catch (e) {
        toast(t('errorGeneric'));
      } finally {
        busy = false;
      }
    }

    function bindAddButtons(scope) {
      (scope || grid).querySelectorAll('.areon-sample__add').forEach((btn) => {
        if (btn.dataset.areonBound) return;
        btn.dataset.areonBound = '1';
        btn.addEventListener('click', () => toggle(parseInt(btn.dataset.variantId, 10)));
      });
    }
    bindAddButtons();

    checkoutBtn.addEventListener('click', () => {
      window.location.href = `${window.Shopify.routes.root}checkout`;
    });

    /* ---------- Suodatus (tyyppinapit) + tekstihaku ---------- */
    const filterBtns = grid.querySelectorAll('.areon-sample__filter');
    const searchInput = grid.querySelector('[data-sample-search]');
    const noResults = grid.querySelector('[data-sample-noresults]');
    let activeFilter = 'all';
    let searchTerm = '';

    function applyFilters() {
      let visible = 0;
      grid.querySelectorAll('.areon-sample__card').forEach((card) => {
        const type = card.dataset.type || '';
        const haystack = card.dataset.search || '';
        const matchType = activeFilter === 'all' || type === activeFilter;
        const matchSearch = searchTerm === '' || haystack.indexOf(searchTerm) !== -1;
        const show = matchType && matchSearch;
        card.style.display = show ? '' : 'none';
        if (show) visible++;
      });
      if (noResults) noResults.hidden = visible > 0;
    }

    filterBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        filterBtns.forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        activeFilter = btn.dataset.filter;
        applyFilters();
      });
    });

    if (searchInput) {
      searchInput.addEventListener('input', () => {
        searchTerm = searchInput.value.trim().toLowerCase();
        applyFilters();
      });
    }

    /* ---------- ?stone= -esivalinta (data-handle, vankka match) ---------- */
    function highlightFromQuery() {
      const params = new URLSearchParams(window.location.search);
      const stone = params.get('stone');
      if (!stone) return;
      const wanted = stone.toLowerCase();
      let match = null;
      grid.querySelectorAll('.areon-sample__card').forEach((card) => {
        const handle = (card.dataset.handle || '').toLowerCase();
        const search = (card.dataset.search || '').toLowerCase();
        // 1) suora handle-osuma  2) nimi sisältää haetun  3) haettu sisältää nimen
        if (
          !match &&
          (handle === wanted ||
            search.indexOf(wanted.replace(/-/g, ' ')) !== -1 ||
            wanted.indexOf(handle) !== -1)
        ) {
          match = card;
        }
      });
      if (match) {
        match.classList.add('is-highlight');
        match.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(() => match.classList.remove('is-highlight'), 2400);
      }
    }
    highlightFromQuery();

    /* ---------- Lataa loput sivut (kaikki kivet gridiin suodatusta varten) ---------- */
    (function loadRemainingPages() {
      var ul = grid.querySelector('[data-sample-grid]');
      if (!ul) return;
      var totalPages = parseInt(ul.dataset.totalPages, 10) || 1;
      var secId = ul.dataset.sectionId;
      if (totalPages < 2 || !secId) return;

      var base = window.location.pathname;
      var chain = Promise.resolve();
      for (var p = 2; p <= totalPages; p++) {
        (function (page) {
          chain = chain.then(function () {
            return fetch(base + '?section_id=' + secId + '&page=' + page)
              .then(function (r) { return r.text(); })
              .then(function (html) {
                var doc = new DOMParser().parseFromString(html, 'text/html');
                var newCards = doc.querySelectorAll('.areon-sample__card');
                newCards.forEach(function (card) {
                  ul.appendChild(document.importNode(card, true));
                });
              })
              .catch(function () { /* hiljainen */ });
          });
        })(p);
      }
      chain.then(function () {
        bindAddButtons();     // kytke napit uusiin kortteihin
        applyFilters();       // suodatus kattaa nyt kaikki
        if (typeof refresh === 'function') refresh(); // päivitä valittu-tilat
      });
    })();

    refresh();
  }

  /* ---------- Globaali checkout-suoja ---------- */
  /* Estää kassalle siirtymisen kaikilla reiteillä jos sampleja > MAX.
     Tämä on selkäranka sen varalta että UI ohitetaan. */
  function enforceCheckoutGuards(count, max) {
    const over = count > max;
    const msg = t('checkoutBlocked', { '%MAX%': max });

    // Cart-sivun checkout
    const cartCheckout = document.getElementById('checkout');
    if (cartCheckout) toggleGuard(cartCheckout, over, msg);

    // Cart notification -popupin Kassa-nappi (form[id=cart-notification-form])
    const notifBtn = document.querySelector('#cart-notification-form button[name="checkout"]');
    if (notifBtn) toggleGuard(notifBtn, over, msg);

    // Dynaamiset checkout-napit (Shop Pay ym.)
    document.querySelectorAll('.cart__dynamic-checkout-buttons, .additional-checkout-buttons').forEach((el) => {
      el.style.display = over ? 'none' : '';
    });
  }

  function toggleGuard(btn, over, msg) {
    if (over) {
      btn.setAttribute('disabled', 'disabled');
      btn.dataset.areonGuarded = 'true';
      showCartError(msg);
    } else if (btn.dataset.areonGuarded === 'true') {
      btn.removeAttribute('disabled');
      delete btn.dataset.areonGuarded;
      showCartError('');
    }
  }

  function showCartError(msg) {
    let box = document.getElementById('cart-errors');
    if (!box) {
      const notif = document.getElementById('cart-notification-product');
      if (notif && msg) {
        let n = document.getElementById('areon-sample-error');
        if (!n) {
          n = document.createElement('div');
          n.id = 'areon-sample-error';
          n.style.cssText = 'color:rgb(var(--color-foreground));font-size:1.3rem;margin:1rem 0;';
          notif.parentNode.insertBefore(n, notif.nextSibling);
        }
        n.textContent = msg;
        return;
      }
    }
    if (box) box.textContent = msg || '';
  }

  /* Lue MAX gridistä, fallback 2. Käytetään kaikissa globaaleissa suojissa. */
  function globalMax() {
    const g = document.querySelector('[id^="areon-sample-grid-"]');
    return g ? parseInt(g.dataset.maxSamples, 10) || 2 : 2;
  }

  async function runGuard() {
    try {
      const cart = await getCart();
      enforceCheckoutGuards(countSamples(cart), globalMax());
    } catch (e) {}
  }

  /* Validoi aina kun grid päivittää korin */
  document.addEventListener('areon:sample-updated', runGuard);

  /* Cart notification renderöi sisältönsä (ml. Kassa-napin) uudelleen joka
     kerta kun tuote lisätään koriin — disablointi katoaisi muuten. Kuunnellaan
     popupin avautumista ja ajetaan suoja uudelleen. */
  function watchNotification() {
    const notif = document.getElementById('cart-notification');
    if (!notif) return;
    // class "active" lisätään kun popup avautuu
    const obs = new MutationObserver(() => {
      if (notif.classList.contains('active')) runGuard();
    });
    obs.observe(notif, { attributes: true, attributeFilter: ['class'] });
  }

  /* Sama cart-sivun osioiden uudelleenrenderöinnille (Dawn vaihtaa #checkout). */
  function watchCartSection() {
    const target = document.getElementById('main-cart-footer');
    if (!target) return;
    const obs = new MutationObserver(() => runGuard());
    obs.observe(target, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', () => {
    watchNotification();
    watchCartSection();
    runGuard();
  });

  // Aja kerran heti (jos DOM jo valmis)
  if (document.readyState !== 'loading') {
    watchNotification();
    watchCartSection();
  }
  runGuard();
})();
